
const trans = {
  'cartoon-and-humour': 'cartoon-or-humor',
  '3d-sl-cgi-rendering': '3d'
}

export default {
  getNewsTag: function (gallery) {
    let res = gallery.url.split('/').pop()
    if(trans[res]) {
      return trans[res]
    }
    return res
  }
}